// removed by extract-text-webpack-plugin
module.exports = {"container":"_3KTCdJQMr7qH5_hi7aKr23","content":"_1CiQug_P3LKvtT9UPMWr7-","removed":"_3UfrnXqppLkH2L65PjbmUh"};


//////////////////
// WEBPACK FOOTER
// ./app/components/Work/style.scss
// module id = 1250
// module chunks = 0